var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "XS Icon Doctor Profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 19.11 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 2",
    d: "M17.1 18H2.01C2 17.877 2 17.758 2 17.645c0-3.726 3.39-6.756 7.556-6.756s7.554 3.03 7.554 6.756c0 .118 0 .237-.01.354zM5.555 6a4 4 0 114 4 4 4 0 01-4-4z"
  })));
}

export default SvgProfile;